<div class="row">
  <div class="col-sm-12">
    <h2 class="text-primary mt-3">{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BeneficiaryObservations.Title' | translate}}</h2>
  </div>
</div>

<div class="row">
  <!--Observações-->
  <div class="col-sm-12">
    <label for="observations" [class.disabled]="isNotStateRLDiferido()"
           >{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BeneficiaryObservations.Fields.AdditionalObservations' | translate}}</label>
    <div class="position-relative">
      <textarea class="form-control input-right" rows="3" type="text" [(ngModel)]="cardData.additionalObservations"
                            [maxLength]="300"
                [disabled]="isNotStateRLDiferido()"
                #additionalObservations="ngModel" name="additionalObservations"
                placeholder="{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BeneficiaryObservations.Fields.AdditionalObservationsPlaceholder' | translate}}"
                messageFieldType="string"></textarea>
    </div>
  </div>
</div>
